import a from "vue";
import p from "uuid";
import m from "./notification.vue.js";
import { getTopZindex as g, isVNode as h } from "../../utils/dom.js";
const x = a.extend(m), y = {
  duration: 5e3,
  position: "top-right",
  offset: 0,
  title: void 0,
  message: void 0,
  type: void 0,
  showClose: !0,
  onClose: null,
  customClass: "",
  dangerouslyUseHTMLString: !1
};
let o;
const i = [], l = function(n) {
  const t = { ...y, ...n }, r = t.onClose, c = `notification_${p()}`;
  t.onClose = function() {
    l.close(c, r);
  }, o = new x({
    data: t
  }), o.id = c, o.$mount(), document.body.appendChild(o.$el), o.visible = !0, o.dom = o.$el;
  const f = 2001, d = g() + 1;
  o.dom.style.zIndex = Math.max(d, f);
  let e = t.offset;
  return i.filter((s) => s.position === t.position).forEach((s) => {
    e += s.$el.offsetHeight + 16;
  }), e += 16, o.verticalOffset = e, i.push(o), o;
};
["success", "warning", "info", "error"].forEach((n) => {
  l[n] = (t) => ((typeof t == "string" || h(t)) && (t = {
    message: t
  }), t.type = n, l(t));
});
l.close = function(n, t) {
  let r = -1;
  const c = i.length, f = i.filter((e, s) => e.id === n ? (r = s, !0) : !1)[0];
  if (!f || (typeof t == "function" && t(f), i.splice(r, 1), c <= 1))
    return;
  const d = f.dom.offsetHeight;
  for (let e = r; e < c - 1; e++)
    if (i[e].position === f.position) {
      const s = f.position.includes("top") ? "top" : "bottom", u = parseInt(i[e].dom.style[s], 10) - d - 16;
      i[e].dom.style[s] = `${u}px`;
    }
};
l.closeAll = function() {
  for (let n = i.length - 1; n >= 0; n--)
    i[n].close();
};
export {
  l as default
};
//# sourceMappingURL=pendo-notification.js.map
